import Messanger from "./components/Messanger";
import { GoogleOAuthProvider } from '@react-oauth/google';

function App() {

  const AuthId='824351194150-emep3klrjc2dtav3ikph2ak833o4qo8k.apps.googleusercontent.com';
  return (
    
    <GoogleOAuthProvider clientId={AuthId}>
      <Messanger/>
    </GoogleOAuthProvider>
    
  );
}

export default App;
